import {useFetch} from "../useFetch";
import {GroupGeofence} from "../../types/api/guide/groupGeofence.types";
import {groupGeofenceService} from "../../services/guide/groupGeofence-service";

const EMPTY: GroupGeofence[] = [];

export const useFetchAllGroupGeofence = () => {
    const { isLoading, error, data, refetch } = useFetch<GroupGeofence[]>(groupGeofenceService.getAll);

    return { data: data ?? EMPTY, isLoading, error, refetch };
}